
import { useAuth } from "@/hooks/useAuth"
import { useAssessments, useAssessmentsCount } from "./useAssessments"
import { useChatMarkComplete } from "./useChatMarkComplete"
import { useChatStatuses } from "./useChatStatuses"
import { useUnreadCounts } from "./useUnreadCounts"

interface UseChatOptions {
  page?: number
  pageSize?: number
}

export const useChats = ({ page = 1, pageSize = 20 }: UseChatOptions = {}) => {
  const { user } = useAuth()
  const { data: assessments = [], isLoading: isLoadingAssessments } = useAssessments({ page, pageSize })
  const { data: totalCount = 0 } = useAssessmentsCount()
  const { chatStatuses, setChatStatuses, isLoading: isLoadingStatuses } = useChatStatuses(user?.id)
  const { unreadCounts, setUnreadCounts, isLoading: isLoadingUnread } = useUnreadCounts(user?.id)
  const { handleMarkComplete, isMarkingComplete } = useChatMarkComplete(setChatStatuses, setUnreadCounts)

  const isLoading = isLoadingAssessments || isLoadingStatuses || isLoadingUnread

  return {
    assessments,
    totalCount,
    chatStatuses,
    unreadCounts,
    handleMarkComplete,
    isMarkingComplete,
    isLoading
  }
}
